import { render, staticRenderFns } from "./ViewFormRF04_1.vue?vue&type=template&id=683ef6c0"
import script from "./ViewFormRF04_1.vue?vue&type=script&lang=js"
export * from "./ViewFormRF04_1.vue?vue&type=script&lang=js"
import style0 from "./ViewFormRF04_1.vue?vue&type=style&index=0&id=683ef6c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports